// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__ro2UD","col":"styles_col__NHRlU"};